/**
 * LayoutsPanel component
 * @constructor editor.mediatabs.LayoutsPanel
 * @param {object} dom DOM
 */
fx.ns("desktop.common.panels", class LayoutsPanel extends fx.components.Box
{
    
    constructor(model)
	{
		super(model);

		this.layouts = model.layouts;
        this._book = model.creation;

		this.listenUpdates(model.creation);
		
	}

	get book()
	{
		return this._book;
	}

	set book(val)
	{
		this._book = val;
	}
	
	get currentArea()
	{
		return this._currentArea;
	}

	set currentArea(val)
	{
		this._currentArea = val;

        // TODO : check if needed
		//if (this.layoutFilter)
		//	this.layoutFilter.area = this._currentArea;

	}

	create()
	{
		super.create();

		//--------------------- layouts ---------------------//

		this.layoutFilter = new filters.LayoutThemeFilter( this.book.themeid, this.data.choosedThemeTag, this.data.themes, "recommended" );
		this.layoutFilter.search = "";

		
		this.layoutsGrid = new fx.components.VerticalGridDynamic( { className : "layoutGrid",
																	data : this.layouts,
																	filter : this.layoutFilter,
																	maxElementsPerRow : 2,
																	maxRowHeight : 160,
																	newChildEffect : "fade",
																	renderers : {ThemeLayout : shared.renderers.LayoutRenderer} 
																} );
                                                                
		this.addChild( new fx.components.Text({className : "coverTitle", text : fx.text("Mises en pages")}), {width : "100%",height : 20, top : 20, left : 0});
		this.addChild(this.layoutsGrid, {height:"fill", width:"100%", top : 50});
		


	}

	/****** Events ******/


	/****** Functions ******/

});
